/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RiskIDRequestBody,
  RiskIDRequestBody$Outbound,
  RiskIDRequestBody$outboundSchema,
} from "../components/riskidrequestbody.js";

export type RevokeRiskPolicyBypassRequestSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RevokeRiskPolicyBypassRequestSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RevokeRiskPolicyBypassRequestSecurity = {
  option1?: RevokeRiskPolicyBypassRequestSecurityOption1 | undefined;
  option2?: RevokeRiskPolicyBypassRequestSecurityOption2 | undefined;
};

export type RevokeRiskPolicyBypassRequestRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  riskIDRequestBody: RiskIDRequestBody;
};

/** @internal */
export type RevokeRiskPolicyBypassRequestSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RevokeRiskPolicyBypassRequestSecurityOption1$outboundSchema:
  z.ZodMiniType<
    RevokeRiskPolicyBypassRequestSecurityOption1$Outbound,
    RevokeRiskPolicyBypassRequestSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function revokeRiskPolicyBypassRequestSecurityOption1ToJSON(
  revokeRiskPolicyBypassRequestSecurityOption1:
    RevokeRiskPolicyBypassRequestSecurityOption1,
): string {
  return JSON.stringify(
    RevokeRiskPolicyBypassRequestSecurityOption1$outboundSchema.parse(
      revokeRiskPolicyBypassRequestSecurityOption1,
    ),
  );
}

/** @internal */
export type RevokeRiskPolicyBypassRequestSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RevokeRiskPolicyBypassRequestSecurityOption2$outboundSchema:
  z.ZodMiniType<
    RevokeRiskPolicyBypassRequestSecurityOption2$Outbound,
    RevokeRiskPolicyBypassRequestSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function revokeRiskPolicyBypassRequestSecurityOption2ToJSON(
  revokeRiskPolicyBypassRequestSecurityOption2:
    RevokeRiskPolicyBypassRequestSecurityOption2,
): string {
  return JSON.stringify(
    RevokeRiskPolicyBypassRequestSecurityOption2$outboundSchema.parse(
      revokeRiskPolicyBypassRequestSecurityOption2,
    ),
  );
}

/** @internal */
export type RevokeRiskPolicyBypassRequestSecurity$Outbound = {
  Option1?: RevokeRiskPolicyBypassRequestSecurityOption1$Outbound | undefined;
  Option2?: RevokeRiskPolicyBypassRequestSecurityOption2$Outbound | undefined;
};

/** @internal */
export const RevokeRiskPolicyBypassRequestSecurity$outboundSchema:
  z.ZodMiniType<
    RevokeRiskPolicyBypassRequestSecurity$Outbound,
    RevokeRiskPolicyBypassRequestSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(
        z.lazy(() =>
          RevokeRiskPolicyBypassRequestSecurityOption1$outboundSchema
        ),
      ),
      option2: z.optional(
        z.lazy(() =>
          RevokeRiskPolicyBypassRequestSecurityOption2$outboundSchema
        ),
      ),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function revokeRiskPolicyBypassRequestSecurityToJSON(
  revokeRiskPolicyBypassRequestSecurity: RevokeRiskPolicyBypassRequestSecurity,
): string {
  return JSON.stringify(
    RevokeRiskPolicyBypassRequestSecurity$outboundSchema.parse(
      revokeRiskPolicyBypassRequestSecurity,
    ),
  );
}

/** @internal */
export type RevokeRiskPolicyBypassRequestRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RiskIDRequestBody: RiskIDRequestBody$Outbound;
};

/** @internal */
export const RevokeRiskPolicyBypassRequestRequest$outboundSchema: z.ZodMiniType<
  RevokeRiskPolicyBypassRequestRequest$Outbound,
  RevokeRiskPolicyBypassRequestRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    riskIDRequestBody: RiskIDRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      riskIDRequestBody: "RiskIDRequestBody",
    });
  }),
);

export function revokeRiskPolicyBypassRequestRequestToJSON(
  revokeRiskPolicyBypassRequestRequest: RevokeRiskPolicyBypassRequestRequest,
): string {
  return JSON.stringify(
    RevokeRiskPolicyBypassRequestRequest$outboundSchema.parse(
      revokeRiskPolicyBypassRequestRequest,
    ),
  );
}
